<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Chimera Prophecies and Other Short Stories</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li><li id="toc-li-5"><a href="#/text/ch005#introduction">Introduction</a></li><li id="toc-li-6"><a href="#/text/ch006#the-chimera-prophecies">The Chimera Prophecies</a></li><li id="toc-li-7"><span href="#/text/ch007#elysian-hills" title="Link target outside of Sample">Elysian Hills</span></li><li id="toc-li-8"><span href="#/text/ch008#the-starlight-hour" title="Link target outside of Sample">The Starlight Hour</span></li><li id="toc-li-9"><span href="#/text/ch009#hello-my-name-is-robert" title="Link target outside of Sample">Hello, My Name Is Robert</span></li><li id="toc-li-10"><span href="#/text/ch010#re-memory-me" title="Link target outside of Sample">Re-Memory Me</span></li><li id="toc-li-11"><span href="#/text/ch011#the-future-is-automaton" title="Link target outside of Sample">The Future Is Automaton</span></li><li id="toc-li-12"><span href="#/text/ch012#the-broken-body" title="Link target outside of Sample">The Broken Body</span></li><li id="toc-li-13"><span href="#/text/ch013#sage-in-a-desert-mirage" title="Link target outside of Sample">Sage In a Desert Mirage</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?806aed26